import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  LayoutDashboard, Users, Radio, Crown, BarChart3, UserCircle, Ban, Settings, Sparkles,
  Images, Film, FileText, MessagesSquare, UserCheck, Landmark, Bell,
} from "lucide-react";
import { StudioLayout } from "@/components/StudioLayout";
import { PeepingLogo } from "@/components/PeepingLogo";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/creator/dashboard", label: "Dashboard Overview", icon: LayoutDashboard, id: "dashboard" },
  { to: "/creator/profile", label: "My Profile", icon: UserCircle, id: "profile" },
  { to: "/creator/promotion", label: "Discovery & Promotion", icon: Sparkles, id: "discovery" },
  { to: "/creator/photos", label: "My Photos", icon: Images, id: "photos" },
  { to: "/creator/videos", label: "My Videos", icon: Film, id: "videos" },
  { to: "/creator/posts", label: "My Posts", icon: FileText, id: "posts" },
  { to: "/creator/live", label: "Go Live", icon: Radio, id: "go-live" },
  { to: "/creator/live-chat", label: "Live Chat & Moderation", icon: MessagesSquare, id: "live-chat" },
  { to: "/creator/subscribers", label: "Subscribers", icon: Users, id: "subscribers" },
  { to: "/creator/followers", label: "Followers", icon: UserCheck, id: "followers" },
  { to: "/creator/membership", label: "Membership Pricing", icon: Crown, id: "membership" },
  { to: "/creator/billing", label: "Tips & Earnings", icon: BarChart3, id: "earnings" },
  { to: "/creator/payouts", label: "Banking & Payouts", icon: Landmark, id: "payouts" },
  { to: "/creator/notifications", label: "Notifications", icon: Bell, id: "notifications" },
  { to: "/creator/account", label: "Account Settings", icon: Settings, id: "account" },
];

function Blocked({ message }) {
  const { logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div data-testid="creator-blocked" className="flex min-h-screen flex-col items-center justify-center bg-[#080808] px-6 text-center">
      <PeepingLogo className="w-40" />
      <Ban size={36} className="mt-8 text-red-300" />
      <p className="mt-4 max-w-sm text-sm text-[#c7c1cf]">{message}</p>
      <button onClick={async () => { await logout(); navigate("/login", { replace: true }); }} data-testid="creator-blocked-logout" className="btn-brand mt-6 rounded-full px-6 py-3 text-sm font-semibold">Log out</button>
    </div>
  );
}

export function CreatorLayout() {
  const [blocked, setBlocked] = useState(null);
  useEffect(() => {
    api.get("/creator/profile").catch((e) => {
      if (e.response?.status === 403) setBlocked(formatApiErrorDetail(e.response.data?.detail));
    });
  }, []);
  if (blocked) return <Blocked message={blocked} />;
  return <StudioLayout nav={NAV} label="Creator Studio" testPrefix="creator" />;
}
